import Vue from 'vue'
import { mapGetters, mapState, mapActions } from 'vuex'
import { uniq } from 'lodash'
import {
  CATEGORY_COLOR_MAP,
  CATEGORY_BACKGROUND_COLOR_MAP,
  CATEGORY_ANNOTATION_MAP,
  CATEGORY_ANNOTATION_COLOR_MAP,
} from '@/constant/Categorise.constant'
import QuizStatuses from '@/constant/QuizStatuses'
import { STATS_TYPES, AGGREGATION_LEVELS } from '@/mqtt/liveStats'
import SlideApi from '@/api/slide'
import EventBus from '@/eventBus'

export default (CategoriseContentView) => Vue.component('CategoriseContentViewController', {
  props: {
    hideBlankCategories: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['isPresenting', 'isBackstage']),
    ...mapGetters({
      categories: 'categorise/slideActiveCategories',
    }),
    ...mapGetters('liveStats', ['correctAnswerCountPerActivity', 'incorrectAnswerCountPerActivity']),
    ...mapState({
      slideActive: (state) => state.slideActive,
      userOnline: (state) => state.userOnline,
    }),
    correctedAnswerPerSlide() {
      return this.correctAnswerCountPerActivity(this.slideActive.id, this.slideActive.version)
    },
    incorrectedAnswerPerSlide() {
      return this.incorrectAnswerCountPerActivity(this.slideActive.id, this.slideActive.version)
    },
    isPresentingOrBackstage() {
      return this.isPresenting || this.isBackstage
    },
    isShowOptions() {
      return this.slideActive.quizStatus === QuizStatuses.RESULT_SCREEN && this.isPresentingOrBackstage
    },
    isShowCorrectAnswer() {
      return this.slideActive.quizStatus === QuizStatuses.RESULT_SCREEN && this.isPresentingOrBackstage
    },
    options() {
      if (!this.categories) return []
      const options = this.categories.reduce((acc, category) => {
        const options = category.options.map((option) => option.value)
        return [...acc, ...options]
      }, [])

      const noDuplicateOptions = uniq(options)

      return noDuplicateOptions.map((option) => ({ value: option }))
    },
    showedCategories() {
      let categories = this.isShowOptions
        ? this.categories
        : this.categories.map((category) => ({ value: category.value, options: [] }))
      if (!this.hideBlankCategories) return categories
      categories = categories.filter((category) => category.value.trim())
      return categories
    },
    totalAnswersPerSlide() {
      const correctAnswer = this.correctedAnswerPerSlide || 0
      const incorrectAnswer = this.incorrectedAnswerPerSlide || 0
      return correctAnswer + incorrectAnswer
    },
  },
  watch: {
    totalAnswersPerSlide(value) {
      console.log('totalAnswersPerSlide', value)
      const multipleCountAnswer = Number(value)
      const payload = { multipleCountAnswer }
      this.updateSlideActiveAction(payload)
      if (this.userOnline === multipleCountAnswer && !this.isShowCorrectAnswer) {
        EventBus.$emit('everyone-voted')
      }
    },
  },
  mounted() {
    console.log('slide active id and version', this.slideActive.id, this.slideActive.version)
    // count per slide
    this.subscribeStatsAction({
      activityId: this.slideActive.id,
      statsType: STATS_TYPES.CORRECT_ANSWER_COUNT,
      aggregationLevel: AGGREGATION_LEVELS.PER_ACTIVITY,
    })

    this.subscribeStatsAction({
      activityId: this.slideActive.id,
      statsType: STATS_TYPES.INCORRECT_ANSWER_COUNT,
      aggregationLevel: AGGREGATION_LEVELS.PER_ACTIVITY,
    })

    this.updateSlideAnswer()
  },
  methods: {
    ...mapActions('liveStats', [
      'subscribeStatsAction',
    ]),
    ...mapActions(['updateSlideActiveAction']),
    async updateSlideAnswer() {
      const { id, version } = this.slideActive
      const answerData = await SlideApi.getSlideAnswer({
        slideId: id,
        version,
      })

      if (!answerData.perActitityStats || answerData.perActitityStats.length === 0) return
      const multipleCountAnswer = answerData.perActitityStats.reduce((acc, stat) => acc + stat.count, 0)
      this.updateSlideActiveAction({ multipleCountAnswer })
    },
  },
  render(createElement) {
    return createElement(CategoriseContentView, {
      props: {
        categories: this.showedCategories,
        options: this.options,
        correctedAnswerPerSlide: this.correctedAnswerPerSlide,
        incorrectedAnswerPerSlide: this.incorrectedAnswerPerSlide,
        isShowCorrectAnswer: this.isShowCorrectAnswer,
        categoryColorMap: CATEGORY_COLOR_MAP,
        categoryBackgroundColorMap: CATEGORY_BACKGROUND_COLOR_MAP,
        categoryAnnotationMap: CATEGORY_ANNOTATION_MAP,
        categoryAnnotationColorMap: CATEGORY_ANNOTATION_COLOR_MAP,
      },
    })
  },
})
